export const ACCESS_TYPE = {
  basic: 'BASIC',
  premium: 'PREMIUM',
  sample: 'SAMPLE',
}

export const ACTIVITIES_TYPE = {
  MAUTHOR: 'MAUTHOR',
  SIMPLE: 'SIMPLE',
  isMauthor(type) {
    return type && type.toLowerCase() === this.MAUTHOR.toLowerCase()
  },
}

export const ACTIVITY_TYPE = {
  cloze: 'CLOZE',
  essay: 'ESSAY',
  isEssay(type) {
    return type && type.toLowerCase() === this.essay.toLowerCase()
  },
}

export const DEFAULT_MAX_ATTEMPTS = 3

export const ATTEMPT_STATUS = {
  finished: 'FINISHED',
  saved: 'SAVED',
}

export const BOOK_TYPES = {
  ACTIVITIES_BOOK: 'ACTIVITIES_BOOK',
  FLIPBOOK_BASIC: 'FLIPBOOK_BASIC',
  FLIPBOOK_TUHAT: 'FLIPBOOK_TUHAT',
  FLIPBOOK_ZOOM: 'FLIPBOOK_ZOOM',
  THEORY_BOOK: 'THEORY_BOOK',
}

export const BOOK_ORIENTATION = {
  landscape: 'LANDSCAPE',
  portrait: 'PORTRAIT',
}

export const BOOK_TEMPLATES = {
  kids: 'KIDS',
  teens: 'TEENS',
}

export const DIFFICULTY_TYPE = {
  1: 'DIFFICULTY_1',
  2: 'DIFFICULTY_2',
  3: 'DIFFICULTY_3',
  no_difficulty: 'NO_DIFFICULTY',
}

export const EDUCATION_LAW_TYPES = {
  LOE: 'LOE',
  LOMCE: 'LOMCE',
  LOMLOE: 'LOMLOE',
}

export const FEEDBACK_TYPES = {
  faceFeedback: 'FACES_STARS',
  numberStarsFeedback: 'NUMBERS_STARS',
  numbersFeedback: 'NUMBERS',
}

export const FINAL_FEEDBACK = {
  numAttempts: 3,
}

export const GRADE_CALCULATION_TYPES = {
  averageOfN: 'AVERAGE_OF_N',
  bestAttempt: 'BEST_ATTEMPT',
  lastAttempt: 'LAST_ATTEMPT',
}

export const HOTLINK_TYPES = {
  media: 'MEDIA',
}

export const MAUTHOR_LISTENER_EVENTS = {
  keyDown: 'KeyDown',
  showErrors: 'ShowErrors',
  valueChanged: 'ValueChanged',
}

export const MAUTHOR_TYPES = {
  cloud: 'CLOUD_LIBRARY',
  gym: 'GYM',
  lesson: 'LESSON',
  open: 'OPEN',
}

export const MAUTHOR_PAGES_TYPES = {
  download: 'DOWNLOAD',
  generic: 'GENERIC',
  open: 'OPEN',
  theory: 'THEORY',
}

export const NAVIGATION_TYPES = {
  legacy: 'LEGACY',
  nav2023: 'NAV_2023',
  open20: 'OPEN_20',
}

export const UNIT_VIEW_FORMAT = {
  HTML: 'HTML',
  PAPER: 'PAPER',
}

export const UNIT_VIEW_PAPER_LAYOUT = {
  double: 'double',
  single: 'single',
}

export const BOTTOM_NAV_VARIANT = {
  compact: 'compact',
  expanded: 'expanded',
  regular: 'regular',
}

export const PAGE_TYPES = {
  activity: 'ACTIVITY',
  animation: 'ANIMATION',
  download: 'DOWNLOAD',
  game: 'GAME',
  open: 'OPEN',
  theory: 'THEORY',
  video: 'VIDEO',
}

export const PHASES_TYPE = {
  learning: 'LEARNING',
  pedagogical: 'PEDAGOGICAL',
}

export const PUBLISHER_ID_CASA_DUARTE = 'd43c9167-5f39-4197-bd80-34fea71d0be9'
export const COLLECTION_FARO = 'FARO'

export const SIMPLE_ACTIVITY_CONTENT_TYPE = {
  jose: 'application/jose',
  json: 'application/json',
}

export const SCORE_TYPES = {
  global: 'GLOBAL',
  individual: 'INDIVIDUAL',
}

export const SUBJECTS_WITH_SPECIAL_LEARNING_PHASE_NAME = {
  BIOLOGIAYGEOLOGIA: 'BIOLOGIA Y GEOLOGIA',
  FISICAYQUIMICA: 'FISICA Y QUIMICA',
}

export const UNIT_TYPES = {
  dossier: 'DOSSIER',
  not_linkable: 'NOT_LINKABLE',
}

export const UNIT_STATUSES = {
  draft: 'DRAFT',
  finished: 'FINISHED',
}

export const USER_ROLE_TYPES = {
  ADMIN: 'ADMIN',
  RELATIVE: 'RELATIVE',
  student: 'STUDENT',
  student_under_14: 'STUDENT_UNDER_14',
  teacher: 'TEACHER',
}

export const TRACKING_ELEMENT_TYPE = {
  audio: 'AUDIO',
  book: 'BOOK',
  image: 'IMAGE',
  paperView: 'PAPER_VIEW',
  section: 'SECTION',
  unit: 'UNIT',
  video: 'VIDEO',
}

export const TRACKING_EVENT_TYPE = {
  accessEvent: 'ACCESS_EVENT',
}

export const TRACKING_ACTIONS_ACCESS_EVENTS = [
  'trackingMultimedia',
  'trackingPaperView',
  'trackingSection',
  'trackingUnit',
]

export const USER_BOOK_STATUS = {
  expired: 'EXPIRED',
}

export const SECTION_BLOCK_TYPE = {
  activities: 'actividades',
  challenge: 'reto',
  standardSection: 'seccion_estandar',
  starActivities: 'actividades_estrella',
}

export const USER_FLAGS = {
  BOOK_INDEX_FULL_WALKTHROUGH: 'BOOK_INDEX_FULL_WALKTHROUGH',
  BOOK_INDEX_SINGLE_WALKTHROUGH: 'BOOK_INDEX_SINGLE_WALKTHROUGH',
  BOOK_SECTION_FULL_WALKTHROUGH: 'BOOK_SECTION_FULL_WALKTHROUGH',
  BOOK_SECTION_PAPER_SINGLE_WALKTHROUGH: 'BOOK_SECTION_PAPER_SINGLE_WALKTHROUGH',
  BOOK_SECTION_SINGLE_WALKTHROUGH: 'BOOK_SECTION_SINGLE_WALKTHROUGH',
}

export const TIMES_TIMEOUT = {
  TIME_TIMEOUT_WALKTHROUGH: 1000,
}

export const DEVICE_SIZE = {
  LAPTOP: '1024px',
  LAPTOP_L: '1440px',
  LAPTOP_M: '1140px',
  LAPTOP_S: '1040px',
  MOBILE_L: '425px',
  MOBILE_M: '375px',
  MOBILE_S: '320px',
  TABLET: '768px',
  TABLET_L: '868px',
  TABLET_S: '520px',
}

export const VIEWS_GRAFANA = {
  ACTIVITY: 'activity',
  ACTIVITY_LIST: 'activity_list',
  BOOK_INDEX: 'book_index',
  CONTENT: 'content',
  DOCUMENTS: 'documents',
  FLIPBOOK: 'flipbook',
  HOTLINK_LIST: 'hotlink_list',
  LESSONS_LIST: 'lessons_list',
  LIBRARY_LIST: 'library_list',
  LINKS_LIST: 'links_list',
  MATERIAL: 'material',
  MAUTHOR: 'mauthor',
  MAUTHOR_ATTEMPT: 'mauthor_attempt',
  MAUTHOR_LIST: 'mauthor_list',
  MULTIMEDIA: 'multimedia',
  MULTIMEDIA_VIDEO: 'multimedia_video',
  NAV2_ACTIVITY: 'activity',
  NAV2_BOOK_INDEX: 'nav2_book_index',
  NAV2_HTML_BOOK: 'nav2_html_book',
  PDF: 'pdf',
  SECTION: 'section',
  SIMPLE_ACTIVITY: 'simple_activity',
  UNIT: 'unit',
  UNIT_COVER: 'unit_cover',
  VIDEO: 'video',
}

export const EVENTS_GRAFANA = {
  click_change_version_to_digital: 'user clicked change to digital version switch',
  click_change_version_to_paper: 'user clicked change to paper version switch',
  click_next_page: 'user clicked next page button',
  click_next_unit: 'user clicked next unit button',
  click_open_thumbnail: 'user clicked paper view thumbnail button',
  click_previous_page: 'user clicked previous page button',
  click_stepper_navigation: 'user navigated between sections using the stepper',
  click_thumbnail: 'user clicked page thumbnail',
  page_number_entered: 'user entered a page number',
  user_click_accessibility_font_button: 'user clicked accessibility font button',
  user_click_accessibility_text_reader_button: 'user clicked accessibility text reader button',
  user_click_accessibility_text_size_button: 'user clicked accessibility text size button',
  user_click_accessibility_theme_button: 'user clicked accessibility theme button',
  user_click_show_user_info: 'user clicked show user info',
}

export const MEASUREMENTS_GRAFANA = {
  loading_unit: 'loading_unit_measurement',
  relocation_duration: 'relocation_duration_measurement',
}

export const TextSize = {
  LARGE: 'LARGE',
  REGULAR: 'REGULAR',
  SMALL: 'SMALL',
  VERYLARGE: 'VERYLARGE',
  VERYSMALL: 'VERYSMALL',
}

export const FontTypography = {
  ARVO: 'Arvo',
  LEXEND: 'Lexend',
  POPPINS: 'Poppins',
  ROBOTO: 'Roboto',
}

export const ThemeMode = {
  CREAM: 'CREAM',
  DARK: 'DARK',
  LIGHT: 'LIGHT',
}

export const CONTENT_MANAGER_USERBOOK_ID = 'CONTENT_MANAGER_USERBOOK_ID'

export const ChatTypes = {
  chatIA: 'chatIA',
  tutorIA: 'tutorIA',
  tutorIAPAU: 'tutorIAPAU',
}

export const CHAT_TYPES_BY_ID = {
  '1f9acfe9-c7de-4f40-aa0a-382d343390b6': 'tutorIA',
  '4c32e5fe-bb9c-4900-a327-8e422e4d0a58': 'tutorIAPAU',
  'f28c2e64-28e2-4102-8e4a-707e9371da9e': 'chatIA',
}
export const OPEN_EDUBOOK_USERBOOK_ID = 'OPEN_EDUBOOK_USERBOOK_ID'
